import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type { Permission, Query } from "@/graphql/codegen/graphql"
import { PermissionListDocument } from "@/graphql/codegen/graphql"

interface UseInstructionFileUploadReturn {
  permissions: Permission[]
  fetching: boolean
}

export const useGetPermissions = (): UseInstructionFileUploadReturn => {
  const [supplierList, setSupplierList] = useState<Permission[]>([])

  const [{ data, fetching }] = useQuery<Pick<Query, "permission">>({
    query: PermissionListDocument,
  })

  useEffect(() => {
    if (!data) return

    const permissions =
      data?.permission?.list?.__typename === "PermissionListSuccess"
        ? (data?.permission?.list?.permissions as Permission[])
        : []

    setSupplierList(permissions)
  }, [data])

  return {
    permissions: supplierList,
    fetching,
  }
}
